"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAssetRequestToJSON = exports.UpdateAssetRequestFromJSONTyped = exports.UpdateAssetRequestFromJSON = exports.instanceOfUpdateAssetRequest = exports.UpdateAssetRequestRevisionCodeEnum = exports.UpdateAssetRequestRejectionCodeEnum = exports.UpdateAssetRequestActionEnum = void 0;
var runtime_1 = require("../runtime");
var AssetType_1 = require("./AssetType");
var AudioType_1 = require("./AudioType");
/**
 * @export
 */
exports.UpdateAssetRequestActionEnum = {
    ApproveVoiceover: 'APPROVE_VOICEOVER',
    RejectVoiceover: 'REJECT_VOICEOVER',
    ApproveScript: 'APPROVE_SCRIPT',
    ReviseScript: 'REVISE_SCRIPT',
    ReviseVoiceover: 'REVISE_VOICEOVER'
};
/**
 * @export
 */
exports.UpdateAssetRequestRejectionCodeEnum = {
    ProjectCancelled: 'REJECTION_PROJECT_CANCELLED',
    ProjectSubmittedIncorrectly: 'REJECTION_PROJECT_SUBMITTED_INCORRECTLY',
    WantToChangeActor: 'REJECTION_WANT_TO_CHANGE_ACTOR',
    ProjectTooLate: 'REJECTION_PROJECT_TOO_LATE',
    CancelAdOther: 'REJECTION_CANCEL_AD_OTHER'
};
/**
 * @export
 */
exports.UpdateAssetRequestRevisionCodeEnum = {
    ReviseScript: 'REVISE_SCRIPT',
    RevisePronunciation: 'REVISE_PRONUNCIATION',
    ReviseTone: 'REVISE_TONE',
    ReviseVoiceActor: 'REVISE_VOICE_ACTOR',
    ReviseDuration: 'REVISE_DURATION',
    RevisionCodeOther: 'REVISION_CODE_OTHER'
};
/**
 * Check if a given object implements the UpdateAssetRequest interface.
 */
function instanceOfUpdateAssetRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "assetType" in value;
    return isInstance;
}
exports.instanceOfUpdateAssetRequest = instanceOfUpdateAssetRequest;
function UpdateAssetRequestFromJSON(json) {
    return UpdateAssetRequestFromJSONTyped(json, false);
}
exports.UpdateAssetRequestFromJSON = UpdateAssetRequestFromJSON;
function UpdateAssetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assetType': (0, AssetType_1.AssetTypeFromJSON)(json['asset_type']),
        'assetSubtype': !(0, runtime_1.exists)(json, 'asset_subtype') ? undefined : (0, AudioType_1.AudioTypeFromJSON)(json['asset_subtype']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'action': !(0, runtime_1.exists)(json, 'action') ? undefined : json['action'],
        'instructions': !(0, runtime_1.exists)(json, 'instructions') ? undefined : json['instructions'],
        'rejectionReason': !(0, runtime_1.exists)(json, 'rejection_reason') ? undefined : json['rejection_reason'],
        'rejectionCode': !(0, runtime_1.exists)(json, 'rejection_code') ? undefined : json['rejection_code'],
        'revisionCode': !(0, runtime_1.exists)(json, 'revision_code') ? undefined : json['revision_code'],
    };
}
exports.UpdateAssetRequestFromJSONTyped = UpdateAssetRequestFromJSONTyped;
function UpdateAssetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asset_type': (0, AssetType_1.AssetTypeToJSON)(value.assetType),
        'asset_subtype': (0, AudioType_1.AudioTypeToJSON)(value.assetSubtype),
        'name': value.name,
        'action': value.action,
        'instructions': value.instructions,
        'rejection_reason': value.rejectionReason,
        'rejection_code': value.rejectionCode,
        'revision_code': value.revisionCode,
    };
}
exports.UpdateAssetRequestToJSON = UpdateAssetRequestToJSON;
